import React from "react";
import cn from "classnames";
import styles from "./Events.module.sass";
import Icon from "../../../components/Icon";
import ScrollParallax from "../../../components/ScrollParallax";

const items = [
  {
    title: "Coffee Chats",
    description: "Thu 8/28 - Thu 9/4",
    color: "#23262F",
    image: "/images/content/cup.svg", // Assuming the image is the same
    status: "outlined",
    statusContent: "In-Person",
    link: "https://fluff-mole-50d.notion.site/24df36646ccb81189785cafb15d69942?v=24df36646ccb80ebbdcc000c58d264e8",
  },
  {
    title: "Clubs & Cookies",
    description: "Fri 8/29, 8:00 PM-10:00 PM",
    color: "#23262F",
    image: "/images/content/user-yellow.svg", // Assuming the image is the same
    status: "outlined",
    statusContent: "Dwinelle 155",
  },
  // {
  //   title: "Clubs & Cookies",
  //   description: "TBA",
  //   color: "#23262F",
  //   image: "/images/content/star.svg", // Assuming the image is the same
  //   status: "outlined",
  //   statusContent: "TBA",
  // },
  {
    title: "Women’s Mixer",
    description: "Mon 9/1, 5:00 PM-7:00 PM",
    color: "#23262F",
    image: "/images/content/globe.svg", // Assuming the image is the same
    status: "outlined",
    statusContent: "The Standard",
  },
  {
    title: "Technical Workshop",
    description: "Mon 9/1, 7:00 PM-8:30 PM",
    color: "#23262F",
    image: "/images/content/info.svg", // Assuming the image is the same
    status: "outlined",
    statusContent: "The Standard",
  },
  // {
  //   title: "Design Fair",
  //   description: "Fri 1/24, 6:00 PM-8:00 PM",
  //   color: "#23262F",
  //   image: "/images/content/mouse-yello.svg", // Assuming the image is the same
  //   status: "outlined",
  //   statusContent: "Jacobs 310",
  // },
  {
    title: "Member Mixer",
    description: "Tue 9/2, 7:00 PM-9:00 PM",
    color: "#23262F",
    image: "/images/content/info.svg", // Assuming the image is the same
    status: "outlined",
    statusContent: "The Standard Courtyard (2nd Floor)",
  },
  {
    title: "Info Session",
    description: "Wed 9/3, 8:00 PM-10:00 PM",
    color: "#23262F",
    image: "/images/content/info.svg", // Assuming the image is the same
    status: "outlined",
    statusContent: "YWCA",
  },
  {
    title: "Cross-Club DEI Mixer",
    description: "Wed 9/3, 5:00 PM-7:00 PM",
    color: "#23262F",
    image: "/images/content/info.svg", // Assuming the image is the same
    status: "outlined",
    statusContent: "Soda Hall 405",
  },
  {
    title: "Application Due",
    description: "Thu 9/4, 11:59 PM",
    color: "#23262F",
    image: "/images/content/time.svg", // Assuming the image is the same
    status: "outlined",
    statusContent: "Online",
    link: "https://noteforms.com/forms/blockchain-at-berkeley-fa25-application-ljqlfw",
  },
  // {
  //   title: "Resume Acceptances Sent",
  //   description: "Fri 1/31",
  //   color: "#23262F",
  //   image: "/images/content/time.svg", // Assuming the image is the same
  //   status: "outlined",
  //   statusContent: "Online",
  // },
];

const Events = () => {
  return (
    <div className={cn("section", styles.section)}>
      <div className={cn("container", styles.container)}>
        <h2 className={cn("h2", styles.title)}>Recruitment Timeline</h2>
        <div className={styles.list}>
          {items.map((x, index) => (
            <ScrollParallax className={styles.item} key={index}>
              {x.link ? (
                <a
                  href={x.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  <div
                    className={styles.preview}
                    style={{ backgroundColor: x.color }}
                  >
                    <img src={x.image} alt="Logo" />
                  </div>
                </a>
              ) : (
                <div
                  className={styles.preview}
                  style={{ backgroundColor: x.color }}
                >
                  <img src={x.image} alt="Logo" />
                </div>
              )}
              <div className={styles.details}>
                {x.status && (
                  <div
                    className={cn(
                      { "status-stroke-yellow": x.status === "outlined" },
                      styles.status
                    )}
                  >
                    {x.statusContent}
                  </div>
                )}

                <div className={styles.subtitle}>
                  {x.link ? (
                    <a
                      href={x.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.subtitle}
                    >
                      {x.title}
                    </a>
                  ) : (
                    <span>{x.title}</span>
                  )}
                </div>

                <div className={styles.description}>{x.description}</div>
              </div>
            </ScrollParallax>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Events;
